import { Text } from '@dixa/lib-shared-habla';
import { type ReactNode } from 'react';

import styles from './statusRow.module.scss';

type StatusRowProps = {
  icon: ReactNode;
  children: ReactNode;
  'data-testid'?: string;
};

export const StatusRow = ({
  icon,
  children,
  'data-testid': testId,
}: StatusRowProps): JSX.Element => (
  <div className={styles.statusRow} data-testid={testId}>
    <span className={styles.iconSlot}>{icon}</span>
    <Text.Paragraph variant="3" subdued>
      {children}
    </Text.Paragraph>
  </div>
);
